import React from "react";

import {
  getBookingStatusLabel,
  getPaymentStatusLabel,
  getSpotStatusLabel,
} from "../../utils/helper";

// Status -> palette color. Unknown statuses fall back to neutral gray.
const STATUS_COLORS = {
  // Bookings
  accepted: "#2ddf8a",
  paid: "#2ddf8a",
  "payment-pending": "#f5a623",
  "request-pending": "#3b82f6",
  completed: "#6b7280",
  rejected: "#e53935",
  cancelled: "#9ca3af",

  // Spots
  published: "#2ddf8a",
  draft: "#9ca3af",

  // Payments
  succeeded: "#2ddf8a",
  pending: "#f5a623",
  failed: "#e53935",
  refunded: "#3b82f6",
};

const LABEL_RESOLVERS = {
  booking: getBookingStatusLabel,
  spot: getSpotStatusLabel,
  payment: getPaymentStatusLabel,
};

const StatusDot = ({ status, label, kind = "booking" }) => {
  if (!status) return null;
  const color = STATUS_COLORS[status] || "#9ca3af";
  const resolver = LABEL_RESOLVERS[kind] || getBookingStatusLabel;
  const display = label || resolver(status) || status;
  return (
    <span className="status-dot-row">
      <span className="status-dot" style={{ background: color }} />
      <span className="status-dot-label">{display}</span>
    </span>
  );
};

export default StatusDot;
